<div class="relative inline-block">
    <div class="flex flex-row items-center gap-2">
        <p class="text-nside-orange-400 font-semibold whitespace-nowrap">
            Instructions
        </p>
        <button 
            (click)="$event.preventDefault(); openChatbox();"
            class="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white shadow-custom-2"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb">
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                <path d="M9 18h6" />
                <path d="M10 22h4" />
            </svg>
        </button>
    </div>
    <div 
        *ngIf="showChatbox" 
        class="content absolute w-[700px] max-w-screen h-fit max-h-[80vh] z-30 right-5 overflow-y-auto bg-white rounded-xl border border-nside-orange-300 shadow-lg flex flex-col justify-between shadow-custom-2"
    >
        <div class="p-2 rounded-t-xl bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 flex items-center justify-between">
            <h3 class="text-white oswald-font text-lg text-center ms-2">Tips Assistant</h3>
            <button 
                class="p-0.5 rounded-full hover:bg-white/20"
                (click)="$event.preventDefault(); this.onClose();"
            >
                <lucide-icon [name]="icons.Minus" [size]="24" class="text-white"></lucide-icon>
            </button>
        </div>
        <div class="overflow-y-auto p-4 h-full flex flex-row items-start justify-start gap-2 bg-[#f9f9f9]">
            <div class="w-9">
                <span 
                    class="w-9 h-9 flex items-center justify-center text-nside-orange-400 rounded-full shadow-chat-dialog bg-white"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb">
                        <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                        <path d="M9 18h6" />
                        <path d="M10 22h4" />
                    </svg>
                </span>
            </div>
            <div class="w-full flex flex-col justify-start gap-2">
                <div class="w-fit h-full p-2 rounded-tl-xl rounded-br-xl rounded-tr-xl rounded-bl shadow-chat-dialog bg-white">
                    <p>Instructions:</p>
                </div>

                <!-- DASHBOARD INSTRUCTIONS -->
                <div class="w-full h-full overflow-y-auto p-2 rounded-bl-xl rounded-tr-xl rounded-br-xl rounded-tl shadow-chat-dialog break-words flex flex-col gap-2 bg-white">
                    <p>
                        <span class="font-bold">nSide|Tips</span>  is a confidential tip submission system for schools, integrated with the nSide platform. Anyone can report concerns anonymously—whether it's safety threats, bullying, or suspicious behavior. Tips are sent to school officials with instant alerts to ensure fast response and review.
                    </p>
                    <p>
                        Tips can be submitted anonymously by providing the links found in the nSide|Tips dashboard. To provide a general public link, click on the Public Link button. This is a general link that can be used to submit tips to any school within your district by simply typing in the name of a school. To provide your school's specific link, click on School Link button.
                    </p>
                    <p>
                        Tips are categorized as:
                    </p>
                    <p class="pl-4">
                        <span class="inline-flex align-middle w-5 h-5 items-center justify-center">
                            <img src="assets/tip-open.png" alt="nSide Tips Logo" class="">
                        </span> Open
                    </p>
                    <p class="pl-4">
                        <span class="inline-flex align-middle w-5 h-5 items-center justify-center">
                            <img src="assets/tip-in-review.png" alt="nSide Tips Logo" class="">
                        </span> In Review
                    </p>
                    <p class="pl-4">
                        <span class="inline-flex align-middle w-5 h-5 items-center justify-center">
                            <img src="assets/tip-closed.png" alt="nSide Tips Logo" class="">
                        </span> Closed
                    </p>
                    <p>
                        All tips submitted for your school will appear directly in the dashboard with all submitted information and the status of each tip. Tips can be filtered by clicking on the <span class="inline-flex p-2 align-middle items-center justify-center gap-2 rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white">
                            All Statuses
                            <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="m1 1 4 4 4-4" />
                            </svg>
                        </span> filter button based on the status of the tip.
                    </p>
                    <p>
                        To manage a tip, click on the edit 
                        <span class="inline-flex align-middle w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center">
                            <lucide-icon [img]="icons.Pencil" size="20"></lucide-icon>
                        </span> button beside the tip you would like to manage. Change the status of the tip and/or leave notes about the tip's progress directly in the pop-up window. Ensure to click the Submit button to update the tip and its history.
                    </p>
                    <p>
                        To view the history of a tip, click on the View History 
                        <span class="inline-flex align-middle w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center">
                            <lucide-icon [img]="icons.History" size="20"></lucide-icon>
                        </span> button. This provides you with a real-time historical log of all actions completed for a tip in the nSide platform.
                    </p>
                </div>

            </div>
        </div>
    </div>
</div>